import { jsonldAuthorName } from './JsonldStore';

export const updateJsonldAuthorName = (value) => jsonldAuthorName.update((oldValue) => value);

